const Timer = (_date, _refs) => {
    var now = new Date();
    var target_date = _date ? new Date(_date).getTime() : new Date("Thu, 12 Jun 2018 18:00:00").getTime();
    var days, hours, minutes, seconds;

    // var counter_days = document.getElementById("counter_days");
    var counter_hours = window.document.getElementById(_refs.hours.props.id).querySelector(".time");
    var counter_minutes = window.document.getElementById(_refs.minutes.props.id).querySelector(".time");
    var counter_seconds = window.document.getElementById(_refs.seconds.props.id).querySelector(".time");

    var setDate = () => {
        var current_date = new Date().getTime();
        var seconds_left = (target_date - current_date) / 1000;
        if (seconds_left > 0) {
            // days = parseInt(seconds_left / 86400);
            // seconds_left = seconds_left % 86400;
            hours = parseInt(seconds_left / 3600);
            seconds_left = seconds_left % 3600;
            minutes = parseInt(seconds_left / 60);
            seconds = parseInt(seconds_left % 60);
            if (minutes >= 0) {
                // counter_days.innerHTML = days;
                counter_hours.innerHTML = hours < 10 ? "0" + hours : hours;
                counter_minutes.innerHTML = minutes < 10 ? "0" + minutes : minutes;
                counter_seconds.innerHTML = seconds < 10 ? "0" + seconds : seconds;
            }
            else {
                // counter_days.innerHTML = '0';
                counter_hours.innerHTML = '0';
                counter_minutes.innerHTML = '0';
                counter_seconds.innerHTML = '0';
            }
        } else {
            target_date = new Date("Tue, 15 May 2018 00:00:00").getTime();
        }
    }

    setDate();
    setInterval(() => {
        setDate();
    }, 1000);
}

export {
    Timer
}


// WEBPACK FOOTER //
// ./src/Components/NextGame/Ticker/Timer.js